/* eslint-disable no-unused-vars */
import axios from '@/axios.js'
export default {
  /**
   * 返回顶部
   * @param {*} param0 
   * @param {*} param 
   */
  // eslint-disable-next-line
  updateTop({
    commit
  }, param) {
    commit('SET_RETURNS', param)
  },
  updateNav({
    commit
  }, param) {
    commit('SET_NAV', param)
  },
  /**
   * @name 获取底部数据
   * @param {*} param0 
   * @returns 
   */
  getFooter({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/web/set/common/getcategory')
        .then((response) => {
          let result = response.data;
          if (result.success) {
            commit('UPDATE_FOOTER', result.data)
            resolve(response)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getLang({
    commit
  }) {
    const lang = localStorage.getItem('lang') || 'zh'
    commit('SET_LANG', lang)
  },
  /**
   * @name 获取产品类别
   * @param {*} param0 
   */
  getProductCategorys({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/web/get/base/getproductcategorys')
        .then((response) => {
          let result = response.data;
          if (result.success) {
            commit('UPDATE_PRODUCTCATREGORY', result.data)
            commit('UPDATE_ALLPRODUCTCATREGORY', result.data)
            resolve(response)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取产品列表
   * @param {*} param0 
   * @param {*} param 
   */
  getProducts({
    commit
  }, param) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/get/base/getproducts?limit=${param.limit}&page=${param.page}&key=${param.key}&lan=${param.lan}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            commit('UPDATE_PRODUCTS', result.data)
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPageProduct() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/get/base/getpageproduct`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取轮播图
   * @returns 
   */
  getSlider() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/banner/getbyweb`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取首页产品
   * @returns 
   */
  getHomeProduct({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/gethomeproduct`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            console.log('zh', zh)
            commit('UPDATE_HOME', zh)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取在线客服
   * @returns 
   */
  getPageService() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getpageservice`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取导航栏
   */
  getNav() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getnav`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取底部栏
   * @returns 
   */
  getFooter2() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getfooter`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取联系我们
   * @returns 
   */
  getContact() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getcontact`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取招贤纳士
   * @returns 
   */
  getJoinus() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getjoinus`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取新闻页面
   * @returns 
   */
  getNews() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getnews`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /**
   * @name 获取产品页面
   * @returns 
   */
  getProduct() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getproduct`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getNewsDetail({
    commit
  }, param) {
    console.log(commit)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getnewsdetail?limit=${param.limit}&offset=${param.page}&type=${param.type}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getNewsItem({
    commit
  }, param) {
    console.log(commit)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getnewsitem?id=${param.id}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getNavbar() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/get/base/getnavbar`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getProductPage({
    commit
  }, param) {
    console.log(commit)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getproductpage?limit=${param.limit}&offset=${param.page}&type=${param.type}&category=${param.category}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVrPage({
    commit
  }, param) {
    console.log(commit)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getvrpage?limit=${param.limit}&offset=${param.page}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getVideoPage({
    commit
  }, param) {
    console.log(commit)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getvideopage?limit=${param.limit}&offset=${param.page}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getMediaPage({
    commit
  }, param) {
    console.log(commit)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getmediapage?limit=${param.limit}&offset=${param.page}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPdfPage({
    commit
  }, param) {
    console.log(commit)
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getpdfpage?limit=${param.limit}&offset=${param.page}`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            resolve(result.data)
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAboutPage() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getaboutpage`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAbout1Page() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getabout1page`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAbout2Page() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getabout2page`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAbout3Page() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getabout3page`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAbout4Page() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getabout4page`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAbout5Page() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getabout5page`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAbout6Page() {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/setting/getabout6page`)
        .then((response) => {
          let result = response.data;
          if (result.success) {
            const zh = JSON.parse(result.data.zh)
            const en = JSON.parse(result.data.en)
            resolve({
              zh,
              en
            })
          } else {
            reject(result.msg);
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  login({
    commit
  },data) {
    const _this =this;
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/web/page/login?pwd=${data.pwd}`)
        .then((response) => {
          let result = response.data;
          console.log(result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}